import { createSlice } from "@reduxjs/toolkit";

export const fetchErrors = createSlice(
    { 
        name:'errors',
        initialState: {value:""
            },
        reducers: {
            setError:  (state, action) => {
                state.value = action.payload;

            },

            


        }
    }
);
export const {setError} =  fetchErrors.actions;

export default fetchErrors.reducer;